<div class="cart-preview-container flex h-full w-full flex-col">
  <div
    *ngIf="cartService.cart?.items.length || cartService.clonnedOrder || cartService.currentStep === 3"
    class="header-preview flex flex-row items-center justify-between"
  >
    <h2>Resumen de tu pedido:</h2>
    <ion-button *ngIf="cartService.currentStep === 0" class="close" fill="clear" shape="round" (click)="closePreview()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </div>

  <div
    class="resumen-pedido-container flex h-full flex-col gap-5"
    (scroll)="appS.closeAllTooltips()"
    [class.shadowEmptyCart]="
      !cartService.cart?.items.length && !cartService.clonnedOrder && cartService.currentStep !== 3
    "
  >
    <div
      *ngIf="(cartService.cart?.items.length && cartService.currentStep < 2) || cartService.currentStep === 0"
      class="free-shipping-progress-container card flex w-full flex-col gap-4"
    >
      <div class="flex flex-col gap-1">
        <span *ngIf="!cartService.freeShipping"
          >📦 ¡Te faltan <strong>{{ getRemainingAmount() }}€</strong> para el <strong>envío estándar GRATIS</strong> en
          PENÍNSULA!</span
        >
        <span *ngIf="cartService.freeShipping"
          >🥳 ¡Has conseguido el <strong>envío estándar GRATIS</strong> en Península!</span
        >
        <span *ngIf="cartHasBonusWallet && cartHasBonusWallet()" class="text-base leading-4"
          >El envío gratuito no aplica a bonos.</span
        >
      </div>
      <ion-progress-bar
        [ngClass]="{ 'green-progress-bar': cartService.freeShipping }"
        [value]="getProgressBarValue()"
      ></ion-progress-bar>
    </div>

    <ng-template #elseTemplate>
      <div class="emptyCart flex h-full w-full flex-col items-center justify-between gap-6">
        <div class="flex flex-row items-center gap-10 py-2.5">
          <h1>Tu carrito está vacío</h1>
          <img class="img-carrito-vacio" src="../../../assets/images/carrito-vacio.png" alt="Imagen carrito vacio" />
        </div>

        <div class="flex w-full justify-start">
          <ion-button
            class="seguir-comprando-button self-center"
            [ngClass]="{
              'seguir-comprando-button-in-page': !cartService.cart?.items.length && cartService.currentStep > 0,
            }"
            color="dark"
            (click)="closePreview()"
          >
            Seguir comprando
          </ion-button>
        </div>
      </div>
    </ng-template>

    <div
      *ngIf="
        cartService.cart?.items.length || cartService.clonnedOrder || cartService.currentStep === 3;
        else elseTemplate
      "
      class="flex w-full flex-col gap-5"
    >
      <!-- Aquí hay que poner la lista de productos que tienes en el carrito -->

      <!-- Meter las demás cosas del carrito -->

      <div *ngIf="cartService.currentStep < 2" class="product-container flex w-full flex-col gap-5">
        <div *ngIf="productExist(cartService.cart?.items)" class="flex w-full flex-col gap-2.5">
          <div class="cart-items-header flex flex-row items-center gap-[15px] py-[10px]">
            <ion-icon src="../../../assets/icon/carrito.svg"></ion-icon>
            <h2>Los artículos de tu carrito:</h2>
          </div>

          <div
            *ngIf="cartService.currentStep < 2 && printGroupItems(cartService.cart?.items).length"
            class="cart-items-section flex flex-col gap-[15px] p-[20px]"
          >
            <div class="items-subheader flex flex-row flex-wrap items-center justify-between gap-2.5">
              <div class="flex flex-row items-center gap-2.5">
                <ion-icon src="../../../assets/icon/carpeta.svg"></ion-icon>
                <h3>Tus carpetas para imprimir</h3>
              </div>

              <div class="flex grow flex-row items-center justify-end">
                <ion-button
                  *ngIf="cartService.currentStep < 2"
                  color="tertiary"
                  fill="solid"
                  class="flex flex-row items-center justify-center gap-2.5 text-lg"
                  appPreventDoubleClick
                  expand="block"
                  (throttledClick)="newPrintProduct()"
                  [disabled]="cartService.currentStep >= 2"
                >
                  <ion-icon name="add-outline"></ion-icon>
                  <span>Crear otra carpeta</span>
                </ion-button>
              </div>
            </div>

            <div class="divider"></div>

            <div class="flex flex-col items-center gap-2.5 lg:flex-row lg:flex-wrap lg:items-start">
              <ng-container *ngFor="let item of printGroupItems(cartService.cart?.items); let i = index" class="w-full">
                <!--                  <ion-checkbox *ngIf="cartService.currentStep < 2" [checked]="true"></ion-checkbox>-->
                <!-- <app-item-print-product class="w-full" [item]="item" [i]="i"></app-item-print-product> -->
                <app-print-group-folder-item [group]="item" [inCart]="true"></app-print-group-folder-item>
              </ng-container>
            </div>
          </div>

          <div
            *ngIf="existStationeryProducts(cartService.cart?.items)"
            class="cart-items-section flex flex-col gap-[15px] p-[20px]"
          >
            <div class="items-subheader flex flex-row flex-wrap items-center justify-between gap-2.5">
              <div class="flex flex-row items-center gap-2.5">
                <ion-icon src="../../../assets/icon/stationary.svg"></ion-icon>
                <h3>Tus productos de papelería</h3>
              </div>

              <div class="flex grow flex-row items-center justify-end">
                <ion-button
                  *ngIf="cartService.currentStep < 2"
                  color="tertiary"
                  fill="solid"
                  class="flex flex-row items-center justify-center gap-2.5 text-lg"
                  appPreventDoubleClick
                  expand="block"
                  (throttledClick)="goToStationery()"
                  [disabled]="cartService.currentStep >= 2"
                >
                  <span>Ir a papelería</span>
                </ion-button>
              </div>
            </div>

            <div class="divider"></div>

            <div class="flex flex-col gap-[15px]">
              <ng-container *ngFor="let item of cartService.cart.items; let i = index" class="w-full">
                @if (item.product.type !== productType.PRINT) {
                  <app-item-shop-product class="w-full" [item]="item"></app-item-shop-product>

                  @if (i < cartService.cart.items.length - 1) {
                    <div class="divider"></div>
                  }
                }
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div class="order-costs-container flex w-full flex-col gap-2.5">
        <div class="ticket-container flex w-full flex-col">
          <img src="../../../assets/images/div-decorations/div-top-ticket-white.png" draggable="false" class="w-full" />

          <div class="ticket-div flex w-full flex-col gap-5">
            <app-add-coupon
              *ngIf="cartService.currentStep < 2"
              (applyCoupon)="applyCoupon($event)"
              [coupon]="cartService.coupon"
              [orderForm]="orderFormGroup"
              [freeShipping]="cartService.freeShipping"
              [disabled]="disabled"
            ></app-add-coupon>

            <div class="flex flex-row justify-between">
              <ion-text class="text-base font-medium lg:text-lg">Gastos de envío</ion-text>
              <div
                *ngIf="cartService.currentStep === 0"
                class="flex flex-row items-center justify-end gap-2.5 text-base font-medium lg:text-lg"
                style="color: #949494"
              >
                <span>
                  {{
                    !!cartService.shippingType
                      ? (cartService.cart.shipping.price.amt | currency: cartService.cart.shipping.price.cur)
                      : 'Se calcularán más tarde'
                  }}
                </span>
              </div>

              <ion-text *ngIf="cartService.currentStep > 0" class="text-lg font-medium">
                <span>{{
                  !!cartService.shippingType
                    ? (shippingCosts | currency: cartService.cart.shipping.price.cur)
                    : 'Se calcularán más tarde'
                }}</span>
              </ion-text>
            </div>

            <hr />

            <div *ngIf="cartService.coupon" class="flex flex-1 flex-col gap-5">
              <div class="flex flex-1 flex-row items-start justify-between">
                <div class="flex flex-col">
                  <span class="coupon-code-span">{{ cartService.coupon.code.toUpperCase() }}</span>
                  <span class="coupon-description-span text-base font-normal lg:text-lg"
                    >({{ cartService.coupon.title }})</span
                  >
                </div>
                <ion-text *ngIf="cartService.coupon" color="primary" class="discount">
                  {{ cartService.canUseCoupon ? (cartService.getDiscount(discountType.COUPON) | currency) : '' }}
                </ion-text>
              </div>
              <hr />
            </div>

            <div class="flex flex-row justify-between">
              <div class="flex flex-col">
                <ion-text class="text-base font-medium lg:text-lg">Subtotal</ion-text>
                <ion-text class="text-base font-normal lg:text-lg" style="color: #949494">{{ getTaxLabel() }}</ion-text>
              </div>

              <div class="flex flex-col">
                <ion-text
                  class="text-base font-medium lg:text-lg"
                  style="color: #949494"
                  *ngIf="cartService.coupon && !isOnlyFreeShipping(cartService.clonnedOrder)"
                >
                  Antes:
                  <span class="line-through">
                    {{ getBasePrice(cartService.clonnedOrder) | currency: cartService.cart.shipping.price.cur }}
                  </span>
                </ion-text>
                <ion-text class="text-base font-medium lg:text-lg">
                  <span *ngIf="cartService.coupon && !isOnlyFreeShipping(cartService.clonnedOrder)">Ahora: </span>
                  {{
                    cartService.coupon
                      ? (keepMinZero(getAfterPrice(cartService.clonnedOrder))
                        | currency: cartService.cart.shipping.price.cur)
                      : (keepMinZero(getBasePrice(cartService.clonnedOrder))
                        | currency: cartService.cart.shipping.price.cur)
                  }}
                </ion-text>
              </div>
            </div>
            <hr
              *ngIf="
                (cartService.getFutureWallet() + walletService.wallet.balance > 0 || cartService.currentStep === 3) &&
                (cartService.discountWallet || cartService.walletDiscountClonnedOrder)
              "
            />

            <div
              *ngIf="
                (cartService.getFutureWallet() + walletService.wallet.balance > 0 || cartService.currentStep === 3) &&
                (cartService.discountWallet || cartService.walletDiscountClonnedOrder)
              "
              class="flex flex-row justify-between"
            >
              <div>
                <ion-text class="text-lg font-medium">BONO MONEDERO</ion-text>
                <ion-list class="text-lg font-normal" style="color: #949494">
                  <div>
                    Saldo en bono: &nbsp;
                    {{ walletService.wallet.balance | currency }}
                  </div>
                  <div>
                    Saldo añadido: &nbsp;
                    {{ cartService.getFutureWallet() > 0 ? '+' : '' }}{{ cartService.getFutureWallet() | currency }}
                  </div>
                </ion-list>
              </div>

              <ion-text color="primary" class="font-medium">
                {{ cartService.walletDiscountable || cartService.walletDiscountClonnedOrder?.amount > 0 ? '-' : ''
                }}{{ cartService.walletDiscountClonnedOrder?.amount || cartService.walletDiscountable | currency }}
              </ion-text>
            </div>
          </div>

          <img
            src="../../../assets/images/div-decorations/div-between-ticket-white.png"
            draggable="false"
            class="w-full"
          />

          <div class="ticket-div flex flex-row justify-between">
            <div class="flex flex-col gap-2.5">
              <div class="flex flex-row items-end gap-4">
                <ion-text class="text-xl font-semibold lg:text-3xl">TOTAL</ion-text>
                <ion-text class="text-lg font-medium lg:text-xl" style="color: #949494">{{ getTaxLabel() }}</ion-text>
              </div>
              <div class="flex flex-row items-center justify-start gap-[5px]">
                <ion-icon class="text-base lg:text-lg" src="../../../assets/icon/shield.svg"></ion-icon>
                <ion-text class="text-base font-medium leading-none lg:text-lg" style="color: #0acf83"
                  >Pago 100% seguro
                </ion-text>
              </div>
            </div>

            <ion-text class="text-xl font-semibold lg:text-3xl"
              >{{
                !!cartService.shippingType
                  ? ((cartService.clonnedOrder ?? cartService).cart.price.totalAmt
                    | currency: cartService.cart.price.cur)
                  : cartService.coupon
                    ? (keepMinZero(getAfterPrice(cartService.clonnedOrder))
                      | currency: cartService.cart.shipping.price.cur)
                    : (keepMinZero(getBasePrice(cartService.clonnedOrder))
                      | currency: cartService.cart.shipping.price.cur)
              }}
            </ion-text>
          </div>
          <img
            src="../../../assets/images/div-decorations/div-bottom-ticket-white.png"
            draggable="false"
            class="w-full"
          />
        </div>
      </div>
    </div>

    <div class="flex flex-row items-center justify-end">
      <button
        *ngIf="cartService.cart?.items.length && !payingProcess"
        [disabled]="isLoading"
        type="button"
        (click)="onSaveDraft()"
        class="save-draft-order flex h-fit w-fit flex-row items-center gap-2.5"
      >
        <ion-spinner *ngIf="isLoading" name="lines-small"></ion-spinner>
        &nbsp;
        <div class="flex flex-row items-center gap-2.5">
          <ion-icon src="../../../assets/icon/cloud-upload.svg"></ion-icon>
          <span class="text-lg font-semibold leading-none">Guardar pedido para más tarde</span><br />
          <!-- <small>Lo puedes consultar en Menú->Mis pedidos</small> -->
        </div>
      </button>
    </div>

    <ion-text
      *ngIf="cartService.cart?.items.length && !payingProcess"
      class="text-base font-normal"
      style="color: #949494"
      >Si guardas tu pedido para más tarde, lo podrás recuperar desde Mi cuenta > Mis pedidos.
    </ion-text>
  </div>
  <div *ngIf="cartService.cart?.items.length && !payingProcess" class="continuar-envio-container flex w-full flex-col">
    <div class="flex flex-col items-center">
      <ion-button class="w-full" color="dark" (click)="this.goToCart()">
        <div class="flex w-full flex-row items-center justify-between">
          <ion-text>Continuar con el envío</ion-text>
          <ion-text
            >Subtotal
            <span>
              {{
                cartService.coupon
                  ? (keepMinZero(getAfterPrice(cartService.clonnedOrder))
                    | currency: cartService.cart.shipping.price.cur)
                  : (keepMinZero(getBasePrice(cartService.clonnedOrder))
                    | currency: cartService.cart.shipping.price.cur)
              }}
            </span>
          </ion-text>
        </div>
      </ion-button>
      <ion-button fill="clear" (click)="closePreview()">Seguir comprando</ion-button>
    </div>
  </div>
</div>
